//Reset data
export const RESET = "MOTIF_CREATE_RESET"

//Loading
export const SET_TOGGLE_LOADING = "MOTIF_CREATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "MOTIF_CREATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "MOTIF_CREATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "MOTIF_CREATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "MOTIF_CREATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "MOTIF_CREATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "MOTIF_CREATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "MOTIF_CREATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "MOTIF_CREATE_SET_HIDE_MESSAGE"

//Data
export const SET_CREATED = "MOTIF_CREATE_SET_CREATED"
export const SET_IS_CREATED = "MOTIF_CREATE_SET_IS_CREATED"
export const SET_NOT_CREATED = "MOTIF_CREATE_SET_NOT_CREATED"
export const SET_CURRENT_ITEM = "MOTIF_CREATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "MOTIF_CREATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "MOTIF_CREATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "MOTIF_CREATE_SET_HIDE_MODAL"


export const SET_MODAL = "MOTIF_CREATE_SET_MODAL"
export const SET_MODAL_CONTENT = "MOTIF_CREATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "MOTIF_CREATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "MOTIF_CREATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "MOTIF_CREATE_SET_MODAL_TYPE"